var YMK;
var site;

YMK = YMK || {};
site = site || {};

(function ($) {
  Drupal.behaviors.vtoBlockV1 = {
    vtoAPIKey: Drupal.settings.vto.api_key,
    vtoAPIUrl: Drupal.settings.vto.api_url,
    $window: $(window),
    isMobile: $('body').hasClass('device-mobile') || (Modernizr.touch && $(window).width() < 1024),
    vtoEvents: [
      'cameraClosed',
      'cameraFailed',
      'cameraOpened',
      'compare',
      'compareDisabled',
      'chosenModel',
      'chooseModelEntered',
      'closed',
      'engineClosed',
      'liveCameraEntered',
      'loaded',
      'loading',
      'kissDetected',
      'modelLoaded',
      'opened',
      'photoLoaded',
      'photoSaved',
      'reset',
      'uploadPhotoEntered',
      'videoLoaded',
      'shadeFinderStarted',
      'shadeFinderComplete',
      'shadeFinderCancelled',
      'zoom'
    ],
    attach: function (context) {
      var self = this;
      var $modules = $('.js-vto-block', context);
      var script;
      var scriptElement;

      if (self.vtoAPIUrl !== null && self.vtoAPIKey !== null) {
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = self.vtoAPIUrl + self.vtoAPIKey;
        scriptElement = document.getElementsByTagName('script')[0];
        scriptElement.parentNode.insertBefore(script, scriptElement);
      }

      window.ymkAsyncInit = function () {
        $modules.each(function () {
          var $module = $(this);

          self.getDom($module);
          self.getConfig($module);
          self.initVto($module);
          self.setListeners($module);
        });
      };
    },
    getDom: function ($module) {
      var $local = $module;

      $local.nodes = {};
      $local.config = {};
      $local.nodes.cta = $('.js-vto-block-cta', $local);
      $local.nodes.ymk = $('.js-vto-block-container', $local);
      $local.nodes.lightbox = $('.js-vto-block-lightbox', $local);
      $local.nodes.close = $('.js-vto-block-vto-close', $local);
    },
    getConfig: function ($module) {
      var $local = $module;

      $local.config = {};
      $local.config.vtoWidth = $local.data('vtoWidth') || 896;
      $local.config.vtoHeight = $local.data('vtoHeight') || 713;
      if ($local.nodes.cta.data('vtoGuid')) {
        $local.config.vtoGuid = $local.nodes.cta.data('vtoGuid');
      }
    },
    initVto: function ($module) {
      var self = this;
      var vtoParams = {
        width: self.isMobile ? self.$window.width() : $module.config.vtoWidth,
        height: self.isMobile ? self.$window.height() : $module.config.vtoHeight,
        autoOpen: true,
        skinSmoothStrength: 17,
        showCloseBtnOnLauncher: true,
        enableUserConsent: true
      };

      window.YMK.init(vtoParams);
    },
    setListeners: function ($module) {
      var self = this;

      if ($module.config.vtoGuid) {
        $module.nodes.cta.once().on('click', function (e) {
          e.preventDefault();
          window.YMK.open();
          $module.nodes.lightbox.removeClass('hidden');
          $module.nodes.ymk.removeClass('hidden');
        });
      }

      self.vtoEvents.forEach(function (youcamEvent) {
        window.YMK.addEventListener(youcamEvent, function (progress) {
          var eventName;

          if (youcamEvent === 'closed') {
            $module.nodes.lightbox.addClass('hidden');
            $module.nodes.ymk.addClass('hidden');
            self.initVto($module);
          } else if (youcamEvent === 'loaded') {
            YMK.applyMakeupByLook($module.config.vtoGuid);
          }

          if (youcamEvent === 'loading') {
            if (progress === 10) {
              eventName = 'loading-start';
            } else if (progress === 100) {
              eventName = 'loading-complete';
            }
          } else {
            eventName = youcamEvent;
          }
          if (eventName) {
            self.trackEvent(eventName);
          }
        });
      });
    },

    trackEvent: function (eventName) {
      if (site && site.track) {
        site.track.evtLink({
          event_name: 'vto',
          event_category: 'vto',
          event_action: eventName,
          event_label: 'event',
          vendor: 'youcam',
          vto_type: 'Makeup'
        });
      }
    }
  };
})(jQuery);
